import { ReactNode, useEffect, useRef, useState } from "react";

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
  rootMargin?: string;
};

const LazyOnVisible = ({ children, fallback = null, rootMargin = "500px" }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || visible) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { rootMargin },
    );

    io.observe(el);
    return () => io.disconnect();
  }, [rootMargin, visible]);

  return <div ref={ref}>{visible ? children : fallback}</div>;
};

export default LazyOnVisible;